<template>
  <div ref="container">
    <slot></slot>
  </div>
</template>

<script>
  import Vue from 'vue'
  import vis from 'vis';
  import 'vis/dist/vis.css'
  import JsonLayout from '@/components/vue-json-layout/vue-json-layout.vue'
  import SubgroupToggleButton from './subgroup-toggle-button'
  import {isEqual, merge, mergeWith} from 'lodash';
  import {createObjectByEval, computeWindowRangeWithBounds} from '@/utils/commonUtils'

  const JsonLayoutClass = Vue.extend(JsonLayout);
  const SubgroupToggleButtonClass = Vue.extend(SubgroupToggleButton);

  export default {
    name: "vis-timeline",
    props: {
      options: {
        type: Object,
        default: () => {
          return {}
        }
      },
      visibleWindow: {
        type: Array,
        require: true
      },
      items: {
        type: Array,
        require: true
      },
      groups: {
        type: Array,
      },
      nestedGroups: {
        type: Array,
      },
      selectedItemStyle: {
        type: Object,
        default: () => {
          return {
            "border": "2px solid #797979",
            "borderRadius": "4px",
            "boxShadow": "rgba(84, 84, 84, 0.53) 0px 0px 12px 3px"
          }
        }
      }
    },
    data: () => {
      return {
        timeline: null,
        itemDataSet: new vis.DataSet([]),
        groupDataSet: new vis.DataSet([]),
        selectedItems: [],
        openedGroups: [],
        nGroups: {}
      }
    },
    mounted() {
      const self = this;

      this.timeline = new vis.Timeline(this.$refs.container, this.itemDataSet, this.groupDataSet, this.options);
      this.timeline.setWindow(this.visibleWindow[0], this.visibleWindow[1], {"animation": false})

      this.timeline.on("rangechange", e => {
        e.byUser ? this.$emit("changeVisibleWindow", [+e.start, +e.end, self.timeline.body.dom.center.getBoundingClientRect()]) : undefined
      });

      const findItemByEvent = (prop) => prop.what == "item" ? self.itemDataSet.get(prop.item) :
        self.itemDataSet.get({filter: (i) => i.group === prop.group && i.start < prop.time && i.end > prop.time && i.type == "background"}).find(() => true)


      self.timeline.on("click", prop => {
        const item = findItemByEvent(prop)
        if (item && item.selectable) {
          let el = prop.what == "item" ? prop.event.path[2] : prop.event.path[0];//TODO обосновать индексы в массиве
          //console.log(el.parentElement.classList)
          while(el.parentElement!=null&&!el.classList.contains("vis-item")){el=el.parentElement}

          if (self.selectedItems.find(e => e.id == item.id)) {
            self.setSelectedItems(self.selectedItems.filter(e => e.id != item.id))
            mergeWith(el.style, self.selectedItemStyle, (objValue, newValue) => null)
          } else {
            self.setSelectedItems(self.selectedItems.concat(item));
            merge(el.style, self.selectedItemStyle);
          }
        }
      })

      self.timeline.on("contextmenu", prop => {
        const item = findItemByEvent(prop)
        if (item) self.$emit("contextmenu", item)
        prop.event.preventDefault();
      });

      if (this.items)
        this.itemsUpdate(this.items);
    },
    methods: {
      setSelectedItems(selectedItems) {
        this.selectedItems = selectedItems;
        this.$emit('selected', this.selectedItems)
      },
      groupsUpdate() {
        const self = this;
        this.groupDataSet.clear();

        let counter = 0;


        const resultGroups = this.groups.map(group => {

          merge(group, {order: counter++});

          const nestedGroups = self.nestedGroups ? [].concat(self.nestedGroups)
            .map(ng => {
              return merge(createObjectByEval(merge({order: "{index}"}, ng.mapper), {
                "e": group,
                index: counter++
              }), {"entityId": group.id});
            }) : [];

          if (nestedGroups.length) this.nGroups[group.id] = nestedGroups.map(f => f.id);

          return [].concat(group, nestedGroups);
        }).reduce((prev, current) => prev.concat(current), []);//нормализуем массив



        resultGroups.forEach(g => {
          if (g.vueContent === null || typeof g.vueContent !== 'object') return;
          const jsonLayout = new JsonLayoutClass({propsData: {layout: g.vueContent, model: g}});
          jsonLayout.$mount();
          let wrapper = document.createElement('div');
          wrapper.style.width = "100%";

          const subGroups = this.nGroups[g.id];

          if (subGroups) {
            const subgroupToggleButton = new SubgroupToggleButtonClass({
              propsData: {
                active: false,
                onClickCallBack: (isActive) => {
                  const groups = this.groupDataSet.get();
                  groups.filter(group => subGroups.includes(group.id) && group.entityId === g.id).forEach(group => group.visible = isActive);
                  this.groupDataSet.clear();
                  this.groupDataSet.add(groups);

                  if (this.openedGroups.includes(g.id)) this.openedGroups = this.openedGroups.filter(v => v !== g.id);
                  else this.openedGroups.push(g.id);

                  this.$emit('openedGroupsChanged', this.openedGroups);
                }
              }
            });
            subgroupToggleButton.$mount();
            subgroupToggleButton.$el.style.display = "inline-block";
            wrapper.appendChild(subgroupToggleButton.$el);
            const w = document.createElement('div');
            w.style.display = "inline-block";
            w.appendChild(jsonLayout.$el);
            wrapper.appendChild(w);
          } else
            wrapper.appendChild(jsonLayout.$el);

          g.content = wrapper;
        });

        this.groupDataSet.add(resultGroups);
      },
      itemsUpdate(items) {
        const self = this;

        const newOrUdatedItems = items.filter(e => !isEqual(this.itemDataSet.get(e.id), e));//TODO is Deep isEqual?

        const forDeleteItems = this.itemDataSet.get({
          filter:
            (e) => (!items.find(item => item.id == e.id)// не соосвествует ни одному полученному элементу
              && ([].concat(self.groupDataSet.get()).find(group => group.id == e.group))//проверка, что данная группа была запрошена с сервера
              && ((e.end >= self.visibleWindow[0]) && (e.start <= self.visibleWindow[1]))//удаляем только находящиеся в window
            )
        });

        this.itemDataSet.remove(forDeleteItems);
        this.itemDataSet.update(newOrUdatedItems);
      },
      changeWindow(visibleWindow) {
        let [newStartTime, newEndTime, bounds] = visibleWindow;
        if (bounds) {//если третьим параметром идет bounds
          ([newStartTime, newEndTime] = computeWindowRangeWithBounds(newStartTime, newEndTime,
            bounds, this.timeline.body.dom.center.getBoundingClientRect()))
        }
        this.timeline.setWindow(newStartTime, newEndTime, {"animation": false})
      }
    },
    watch: {
      visibleWindow: {
        handler() {
          this.changeWindow(this.visibleWindow);
        }
      },
      groups: {
        handler() {
          this.groupsUpdate();
        }
      },
      items: {
        handler() {
          this.itemsUpdate(this.items);
        }
      }

    }
  }
</script>

<style scoped>

</style>
